module.exports = __webpack_public_path__ + "static/media/Ios1.54b9c4b7.png";